import Rule from "../../../../../common/rule";
import DriveEndType from "../../../../enums/drive-end-type";
import FootballState from "../../../../state/football-state";

export default class FieldChange extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const isPuntReturn =
            fragment.associatedState === FootballState.Returned &&
            [FootballState.Punt, FootballState.CflKick].some(
                (state) =>
                    state === play.getPreviousFragment(fragment).associatedState
            );
        const isPuntBlockReturn =
            fragment.associatedState === FootballState.NoRecoveryKickReturn &&
            play.getPreceedingFragment(fragment, [
                FootballState.OnSide,
                FootballState.FieldGoalBlocked,
                FootballState.PuntBlocked
            ])?.associatedState === FootballState.PuntBlocked;

        return isPuntReturn || isPuntBlockReturn;
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { driveTeamId } = gameContext.driveContext;
        const triggerDrive =
            !driveTeamId || fragment.returnedBy.teamId !== driveTeamId;
        gameContext.setFieldPosition(fragment.returnedAt);
        ruleContext.setAwardFirstDown(triggerDrive);
        gameContext.setPossessionForTeamId(fragment.returnedBy.teamId);
        gameContext.setDriveContext({
            triggerDrive,
            previousDriveEndType: DriveEndType.Punt
        });
    }
}
